import { render, staticRenderFns } from "./TwitterShare.vue?vue&type=template&id=60e5c6a8&"
import script from "./TwitterShare.vue?vue&type=script&lang=ts&"
export * from "./TwitterShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports